const MONTHS_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function formatDate(ts) {
  const d = new Date(ts);
  if (isNaN(d)) return "";
  return `${MONTHS_SHORT[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

export default function Modal({ entry, onClose }) {
  if (!entry) return null;

  return (
    <div
      data-testid="entry-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: "fixed", inset: 0,
        background: "rgba(2,32,26,0.85)",
        zIndex: 200,
        display: "flex", alignItems: "flex-end", justifyContent: "center",
        animation: "fadeIn 0.2s ease",
      }}
    >
      <div
        data-testid="entry-modal-sheet"
        style={{
          background: "var(--forest)",
          borderRadius: "14px 14px 0 0",
          width: "100%", maxWidth: 500,
          maxHeight: "80vh", overflowY: "auto",
          padding: "20px max(24px, var(--safe-left)) calc(40px + var(--safe-bot)) max(24px, var(--safe-right))",
          animation: "slideUp 0.3s ease",
        }}
      >
        {/* Drag handle — 44px tap area */}
        <div
          onClick={onClose}
          style={{
            width: 36, height: 4, borderRadius: 2,
            background: "rgba(29,158,117,0.25)",
            margin: "0 auto 20px",
            cursor: "pointer",
            padding: "10px 0",
            boxSizing: "content-box",
          }}
        />
        <div style={{
          fontFamily: "var(--mono)", fontSize: 11, fontWeight: 300,
          letterSpacing: "0.12em", color: "var(--teal)",
          textTransform: "uppercase", marginBottom: 14,
        }}>
          {formatDate(entry.timestamp || entry.created_at)}
        </div>
        <div style={{
          fontSize: 18, fontStyle: "italic",
          color: "var(--cream)", lineHeight: 1.75, marginBottom: 24,
        }}>
          "{entry.text}"
        </div>
        <button
          onClick={onClose}
          data-testid="modal-close-btn"
          style={{
            width: "100%", height: 44,
            background: "none",
            border: "1px solid var(--teal-border)",
            borderRadius: 6,
            fontFamily: "var(--mono)", fontSize: 12, fontWeight: 300,
            color: "var(--cream-dim)", cursor: "pointer",
            letterSpacing: "0.06em",
            transition: "all 0.2s",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
}
